export const breakpointMinExtraSmall = "@media screen and (min-width: 23em)";
export const breakpointMinSmall = "@media screen and (min-width: 40em)";
export const breakpointMinMedium = "@media screen and (min-width: 60em)";
export const breakpointMinLarge = "@media screen and (min-width: 80em)";
export const breakpointMinExtraLarge = "@media screen and (min-width: 120em)";

export const breakpointMaxExtraSmall = "@media screen and (max-width: 23em)";
export const breakpointMaxSmall = "@media screen and (max-width: 40em)";
export const breakpointMaxMedium = "@media screen and (max-width: 60em)";
export const breakpointMaxLarge = "@media screen and (max-width: 80em)";
export const breakpointMaxExtraLarge = "@media screen and (max-width: 120em)";
